<app-toaster class="toaster" [config]="toasterService.toaster"></app-toaster>
<div class="center">
  <form [formGroup]="shiftFormGroup" class="flex-col width-800">
    <h2 class="center margin-y-10">Create Shift</h2>

    <!-- Info Banner -->
    <div class="info-banner margin-y-10">
      <mat-icon class="info-icon">info</mat-icon>
      <span>Shift name is <strong>permanent</strong> and globally unique — it cannot be renamed after creation.</span>
    </div>

    <!-- Shift Type — aligned with other field rows -->
    <div class="flex-row margin-y-10">
      <label class="width-50 font-16 bold">Shift Type: *</label>
      <div class="flex-grow margin-l-10">
        <div class="shift-type-cards">
          <div class="type-card" [class.active]="shiftType === 'regular'" (click)="setShiftType('regular')">
            <div class="card-title">Regular Shift</div>
            <div class="card-desc">Custom shift with a name like CM or KM_12</div>
          </div>
          <div class="type-card" [class.active]="shiftType === 'default'" (click)="setShiftType('default')">
            <div class="card-title">Default Shift</div>
            <div class="card-desc">The primary shift for a city + mode. Only one per combination.</div>
          </div>
        </div>
      </div>
    </div>

    <!-- City -->
    <div class="flex-row margin-y-10">
      <label class="width-50 font-16 bold">City: *</label>
      <ng-select
        formControlName="city"
        name="city"
        placeholder="Select city"
        class="flex-grow font-16 margin-l-10"
        [clearable]="false">
        <ng-option *ngFor="let item of cities" [value]="item">{{item.name}}</ng-option>
      </ng-select>
    </div>

    <!-- Mode -->
    <div class="flex-row margin-y-10">
      <label class="width-50 font-16 bold">Mode: *</label>
      <ng-select
        formControlName="mode"
        name="mode"
        placeholder="Select mode"
        class="flex-grow font-16 margin-l-10"
        [clearable]="false"
        [disabled]="!shiftFormGroup.get('city').value">
        <ng-option *ngFor="let item of modes" [value]="item">{{item.name}}</ng-option>
      </ng-select>
    </div>

    <!-- Shift Name — always visible -->
    <div class="flex-row margin-y-10">
      <label class="width-50 font-16 bold">Shift Name: *</label>
      <div class="flex-grow margin-l-10 flex-col">

        <!-- Pending: city/mode not yet selected -->
        <div class="unified-name-input pending" *ngIf="!shiftFormGroup.get('mode').value">
          <span class="name-pending">Select city and mode first</span>
        </div>

        <!-- Active: mode selected -->
        <ng-container *ngIf="shiftFormGroup.get('mode').value">
          <div class="unified-name-input" [class.readonly]="shiftType === 'default'">
            <mat-icon class="lock-icon" *ngIf="shiftType === 'default'">lock_outline</mat-icon>
            <span class="name-prefix">{{ cityPrefix }}_{{ modePrefix }}_</span>
            <input
              *ngIf="shiftType === 'regular'"
              formControlName="shiftLabel"
              class="name-tag-input"
              placeholder="MORNING"
              maxlength="30"
              autocomplete="off" />
            <span *ngIf="shiftType === 'default'" class="name-tag-locked">DEFAULT</span>
          </div>
          <span class="name-hint" *ngIf="shiftType === 'regular'">
            Allowed: A–Z, 0–9, underscore and hyphen
          </span>
        </ng-container>

      </div>
    </div>

    <!-- Action Buttons -->
    <div class="flex-row margin-y-20 justify-end">
      <button type="button" class="btn btn-secondary margin-r-10" (click)="onCancel()">
        Cancel
      </button>
      <button
        type="button"
        class="btn btn-primary"
        (click)="onSubmit()"
        [disabled]="shiftFormGroup.invalid || !finalShiftName">
        Create Shift
      </button>
    </div>
  </form>
</div>
